export const getFleetNumber = (machine: EasyTech.Machine) => {
  if (machine.fleetIdentifier)
    return machine.fleetIdentifier;

  if (machine.fleetNumber)
    return machine.fleetNumber.toString();
  return undefined;    
};

export const getHourMeter = (machine: EasyTech.Machine) => {
  if (machine.usageMeter)
    return machine.usageMeter;

  if (machine.hourMeter)
    return machine.hourMeter.toString();
  return undefined;    
};